import { Package, Store, ShieldCheck } from "lucide-react";
import { SectionHeading } from "../components/SectionHeading";
import { Reveal } from "../components/Reveal";

const FEATURES = [
    {
        icon: Package,
        title: "Broad Product Range",
        description: "Everyday consumer products across multiple categories.",
    },
    {
        icon: Store,
        title: "Wholesale & Retail",
        description: "Solutions designed for both businesses and individual customers.",
    },
    {
        icon: ShieldCheck,
        title: "Reliable Service",
        description: "A straightforward, customer-focused approach to supply and enquiries.",
    },
];

export const Trust = () => (
    <section data-testid="trust-features-section" className="border-t border-slate-100 bg-slate-50">
        <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:py-24">
            <SectionHeading
                eyebrow="Who We Are"
                title="A Reliable Partner for Everyday Products"
                subtitle="PISI LIMITED operates across wholesale and retail supply, offering a diverse range of everyday products for customers and businesses. We focus on dependable service, practical product availability and building strong relationships with the people and businesses we serve."
            />
            <div className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                {FEATURES.map((feature, i) => (
                    <Reveal key={feature.title} delay={i * 120}>
                        <div
                            data-testid={`trust-feature-${i + 1}`}
                            className="group h-full border border-slate-200 bg-white p-8 transition-[box-shadow,transform] duration-300 hover:-translate-y-1 hover:shadow-[0_18px_40px_-18px_rgba(15,23,42,0.25)]"
                        >
                            <span className="flex h-12 w-12 items-center justify-center bg-navy-900 text-gold transition-colors duration-300 group-hover:bg-navy-800">
                                <feature.icon className="h-5 w-5" />
                            </span>
                            <h3 className="mt-6 font-heading text-lg font-semibold text-navy-900">
                                {feature.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-slate-600">
                                {feature.description}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
